<div class="p-6 w-[520px] bg-white rounded-lg shadow-md">

    <div class="bg-blue-100 border border-blue-200 rounded-md p-4 mb-6">
        <div class="font-semibold text-blue-900 mb-1">
            IMPORTANT NOTE
        </div>
        <p class="text-sm text-blue-800 leading-relaxed">
            Past the entire public key content. It must include the
            <b>-----BEGIN PUBLIC KEY-----</b> header, the base64 encoded key data and the
            <b>-----END PUBLIC KEY-----</b> footer.
        </p>
    </div>

    <div class="mb-4">
        <h2 class="font-semibold text-gray-800 text-lg mb-2">
            Self-generated Key
        </h2>

        <p class="text-sm text-gray-700 mb-2">
            You generate your own key pair, with Token API Calls securely signed
            using your private key.
        </p>

        <p class="text-sm text-blue-600 mb-4">
            We only require your public key, making this the most secure way to access your token.
        </p>
    </div>

    <textarea [(ngModel)]="publicKey" rows="5"
        class="w-full bg-gray-800 text-white rounded-md p-3 text-sm focus:outline-none focus:ring-2 focus:ring-teal-400"
        placeholder="Enter public key">
    </textarea>

    <div class="flex justify-between items-center mt-5">

        <button class="px-5 py-2 bg-gray-200 text-gray-700 rounded-md font-medium hover:bg-gray-300" (click)="close()">
            No
        </button>

        <button [disabled]="loading"
            class="px-6 py-2 bg-blue-500 text-white rounded-md font-medium hover:bg-blue-600 disabled:opacity-50"
            (click)="submit()">

            {{ loading ? 'Saving...' : 'Save Key' }}

        </button>

    </div>

</div>